// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Lize3","rules":"rules_KAyZD","g-wrapper":"g-wrapper"};